const INCH = 25.4;

export const preDefinedFlowSizes = [
  {
    name: 'EN 933-2 Basic',
    size: [
      0.063, 0.125, 0.25, 0.5, 1, 2, 4, 8, 16, 31.5, 63, 90, 125, 250, 500,
      1000, 1600, 2500,
    ],
  },
  {
    name: 'EN 933-2 Basic +1',
    size: [
      0.063, 0.125, 0.25, 0.5, 1, 2, 4, 5.6, 8, 11.2, 16, 22.4, 31.5, 45, 63,
      90, 125, 250, 500, 1000, 1600, 2500,
    ],
  },
  {
    name: 'EN 933-2 Basic +2',
    size: [
      0.063, 0.125, 0.25, 0.5, 1, 2, 4, 6.3, 8, 10, 12.5, 14, 16, 20, 31.5, 40,
      63, 90, 125, 250, 500, 1000, 1600, 2500,
    ],
  },
  {
    name: 'ASTM C136',
    size: [
      0.075,
      0.15,
      0.3,
      0.6,
      1.18,
      2.36,
      4.75,
      Math.round(((INCH * 3.0) / 8.0) * 100) / 100,
      Math.round((INCH / 2.0) * 100) / 100,
      Math.round(((INCH * 3.0) / 4.0) * 100) / 100,
      Math.round(INCH * 100) / 100,
      Math.round(INCH * 1.5 * 100) / 100,
      Math.round(INCH * 2 * 100) / 100,
      Math.round(INCH * 2.5 * 100) / 100,
      Math.round(INCH * 3 * 100) / 100,
      Math.round(INCH * 3.5 * 100) / 100,
      Math.round(INCH * 4 * 100) / 100,
      Math.round(INCH * 5 * 100) / 100,
      Math.round(INCH * 10 * 100) / 100,
      Math.round(INCH * 20 * 100) / 100,
      Math.round(INCH * 40 * 100) / 100,
      Math.round(INCH * 60 * 100) / 100,
    ],
  },
  {
    name: 'GOST (round holes)',
    size: [
      0.074, 0.25, 1, 2, 4, 5, 10, 20, 25, 30, 40, 60, 70, 90, 150, 200, 300,
      500, 1000, 1600,
    ],
  },
];
